import axios from 'axios'
import decryptData from '@/store/auth/decryptData'

export default {
  namespaced: true,
  state: () => ({
    engineersList: [],
    engineersLoaded: false,
    engineersFetching: false,
  }),
  mutations: {
    SET_ENGINEERS(state, engineers) {
      state.engineersList = engineers
      state.engineersLoaded = true
      state.engineersFetching = false
    },
    SET_FETCHING(state, value) {
      state.engineersFetching = value
    },
  },
  actions: {
    async fetchEngineersList({ commit, state }) {
      if (state.engineersLoaded || state.engineersFetching) return
      commit('SET_FETCHING', true)
      try {
        const res = await axios.get(
          'https://gulftic-system.fci.group/api/engineers/list',
        )
        const data = decryptData(res.data.payload).data.engineers
        const formatted = data.map(item => ({
          value: item.id,
          label: item.name,
        }))
        commit('SET_ENGINEERS', [...formatted])
      } catch (e) {
        commit('SET_FETCHING', false)
      }
    },
  },
  getters: {
    engineersList: state => state.engineersList,
    engineersLoaded: state => state.engineersLoaded,
  },
}
